import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createOrderPaymentRequestRequest = {
    orderPaymentRequest: '_orderPaymentRequest',
};
var _createOrderPaymentRequestResponse = {
    orderPaymentRequest: '_orderPaymentRequest',
};
var _deleteOrderPaymentRequestRequest = {};
var _deleteOrderPaymentRequestResponse = {};
var _getOrderPaymentRequestRequest = {};
var _getOrderPaymentRequestResponse = {
    orderPaymentRequest: '_orderPaymentRequest',
};
var _getOrderPaymentRequestURLRequest = {};
var _getOrderPaymentRequestURLResponse = {};
var _orderPaymentRequest = {
    expirationDate: 'google.protobuf.Timestamp',
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _queryOrderPaymentRequestsRequest = {};
var _queryOrderPaymentRequestsResponse = {
    orderPaymentRequests: '_orderPaymentRequest',
};
var _updateExtendedFieldsRequest = {};
var _updateExtendedFieldsResponse = {
    orderPaymentRequest: '_orderPaymentRequest',
};
var _updateOrderPaymentRequestRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    orderPaymentRequest: '_orderPaymentRequest',
};
var _updateOrderPaymentRequestResponse = {
    orderPaymentRequest: '_orderPaymentRequest',
};
var _voidOrderPaymentRequestRequest = {};
var _voidOrderPaymentRequestResponse = {};
function resolveWixEcomOrderPaymentRequestApiV1OrderPaymentRequestsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/order-payment-request',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/ecom/v1/order-payment-requests',
                destPath: '/v1/order-payment-requests',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/ecom/v1/order-payment-requests',
                destPath: '/v1/order-payment-requests',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/ecom/v1/order-payment-requests',
                destPath: '/v1/order-payment-requests',
            },
        ],
        _: [
            {
                srcPath: '/ecom/v1/order-payment-requests',
                destPath: '/v1/order-payment-requests',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/ecom/v1/order-payment-requests',
                destPath: '/v1/order-payment-requests',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a order payment request. */
export function createOrderPaymentRequest(payload) {
    var _a = serializer(_createOrderPaymentRequestRequest, { _orderPaymentRequest: _orderPaymentRequest }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createOrderPaymentRequestResponse, {
        _orderPaymentRequest: _orderPaymentRequest,
    }).fromJSON;
    function __createOrderPaymentRequest(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order_payment_request',
            method: 'POST',
            methodFqn: 'wix.ecom.order_payment_request.api.v1.OrderPaymentRequestsService.CreateOrderPaymentRequest',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEcomOrderPaymentRequestApiV1OrderPaymentRequestsServiceUrl({ protoPath: '/v1/order-payment-requests', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createOrderPaymentRequest.fromReq = fromReq;
    __createOrderPaymentRequest.__isAmbassador = true;
    return __createOrderPaymentRequest;
}
/** Retrieves a order payment request. */
export function getOrderPaymentRequest(payload) {
    var _a = serializer(_getOrderPaymentRequestRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getOrderPaymentRequestResponse, {
        _orderPaymentRequest: _orderPaymentRequest,
    }).fromJSON;
    function __getOrderPaymentRequest(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order_payment_request',
            method: 'GET',
            methodFqn: 'wix.ecom.order_payment_request.api.v1.OrderPaymentRequestsService.GetOrderPaymentRequest',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEcomOrderPaymentRequestApiV1OrderPaymentRequestsServiceUrl({
                protoPath: '/v1/order-payment-requests/{orderPaymentRequestId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getOrderPaymentRequest.fromReq = fromReq;
    __getOrderPaymentRequest.__isAmbassador = true;
    return __getOrderPaymentRequest;
}
/**
 * Updates a order payment request.
 *
 * Please note that only `UNPAID` payment requests can be updated.
 */
export function updateOrderPaymentRequest(payload) {
    var _a = serializer(_updateOrderPaymentRequestRequest, { _orderPaymentRequest: _orderPaymentRequest }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateOrderPaymentRequestResponse, {
        _orderPaymentRequest: _orderPaymentRequest,
    }).fromJSON;
    function __updateOrderPaymentRequest(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order_payment_request',
            method: 'PATCH',
            methodFqn: 'wix.ecom.order_payment_request.api.v1.OrderPaymentRequestsService.UpdateOrderPaymentRequest',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEcomOrderPaymentRequestApiV1OrderPaymentRequestsServiceUrl({
                protoPath: '/v1/order-payment-requests/{orderPaymentRequest.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateOrderPaymentRequest.fromReq = fromReq;
    __updateOrderPaymentRequest.__isAmbassador = true;
    return __updateOrderPaymentRequest;
}
/**
 * Deletes a order payment request.
 *
 * Please note that only `UNPAID` and `VOIDED` payment requests can be deleted.
 */
export function deleteOrderPaymentRequest(payload) {
    var _a = serializer(_deleteOrderPaymentRequestRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteOrderPaymentRequestResponse, {}).fromJSON;
    function __deleteOrderPaymentRequest(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order_payment_request',
            method: 'DELETE',
            methodFqn: 'wix.ecom.order_payment_request.api.v1.OrderPaymentRequestsService.DeleteOrderPaymentRequest',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEcomOrderPaymentRequestApiV1OrderPaymentRequestsServiceUrl({
                protoPath: '/v1/order-payment-requests/{orderPaymentRequestId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteOrderPaymentRequest.fromReq = fromReq;
    __deleteOrderPaymentRequest.__isAmbassador = true;
    return __deleteOrderPaymentRequest;
}
/**
 * Retrieves a list of Payment Requests, given the provided [paging, filtering, and sorting][1].
 *
 * Query Payment Requests runs with these defaults, which you can override:
 * - `createdDate` is sorted in DESC order
 * - `cursorPaging.limit` is 100
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language), and
 * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
 */
export function queryOrderPaymentRequests(payload) {
    var _a = serializer(_queryOrderPaymentRequestsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryOrderPaymentRequestsResponse, {
        _orderPaymentRequest: _orderPaymentRequest,
    }).fromJSON;
    function __queryOrderPaymentRequests(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order_payment_request',
            method: 'POST',
            methodFqn: 'wix.ecom.order_payment_request.api.v1.OrderPaymentRequestsService.QueryOrderPaymentRequests',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEcomOrderPaymentRequestApiV1OrderPaymentRequestsServiceUrl({
                protoPath: '/v1/order-payment-requests/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryOrderPaymentRequests.fromReq = fromReq;
    __queryOrderPaymentRequests.__isAmbassador = true;
    return __queryOrderPaymentRequests;
}
/** Retrieves the order payment request page URL of a specified order payment request. */
export function getOrderPaymentRequestUrl(payload) {
    var _a = serializer(_getOrderPaymentRequestURLRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getOrderPaymentRequestURLResponse, {}).fromJSON;
    function __getOrderPaymentRequestUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order_payment_request',
            method: 'POST',
            methodFqn: 'wix.ecom.order_payment_request.api.v1.OrderPaymentRequestsService.GetOrderPaymentRequestURL',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEcomOrderPaymentRequestApiV1OrderPaymentRequestsServiceUrl({
                protoPath: '/v1/order-payment-requests/url',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getOrderPaymentRequestUrl.fromReq = fromReq;
    __getOrderPaymentRequestUrl.__isAmbassador = true;
    return __getOrderPaymentRequestUrl;
}
/** Updates extended fields of a order payment request */
export function updateExtendedFields(payload) {
    var _a = serializer(_updateExtendedFieldsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateExtendedFieldsResponse, {
        _orderPaymentRequest: _orderPaymentRequest,
    }).fromJSON;
    function __updateExtendedFields(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order_payment_request',
            method: 'POST',
            methodFqn: 'wix.ecom.order_payment_request.api.v1.OrderPaymentRequestsService.UpdateExtendedFields',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEcomOrderPaymentRequestApiV1OrderPaymentRequestsServiceUrl({
                protoPath: '/v1/order-payment-requests/{id}/update-extended-fields',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateExtendedFields.fromReq = fromReq;
    __updateExtendedFields.__isAmbassador = true;
    return __updateExtendedFields;
}
/**
 * Voids the given order payment request
 *
 * Please note that only `UNPAID` payment requests can be voided.
 */
export function voidOrderPaymentRequest(payload) {
    var _a = serializer(_voidOrderPaymentRequestRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_voidOrderPaymentRequestResponse, {}).fromJSON;
    function __voidOrderPaymentRequest(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.order_payment_request',
            method: 'POST',
            methodFqn: 'wix.ecom.order_payment_request.api.v1.OrderPaymentRequestsService.VoidOrderPaymentRequest',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEcomOrderPaymentRequestApiV1OrderPaymentRequestsServiceUrl({
                protoPath: '/v1/order-payment-requests/void',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __voidOrderPaymentRequest.fromReq = fromReq;
    __voidOrderPaymentRequest.__isAmbassador = true;
    return __voidOrderPaymentRequest;
}
//# sourceMappingURL=http.impl.js.map